export default {
  topicManagerRange_Week_top_list:'周榜',
  topicManagerRange_mouth_top_list:'月榜',
  topicManagerRange_results_count:'找到{count}条记录，显示{from}到{to}条',
  topicManagerRange_ranking:'排名',
  topicManagerRange_user:'用户',
  topicManagerRange_organization:'所属组织',
  topicManagerRange_likes_num:'点赞量',
  topicManagerRange_top_week:"圈主排行榜-周榜",
  topicManagerRange_top_mouth:'圈主排行榜-月榜'

}
